import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getStudentTracksPanel = async (params) => {
  const res = await axios.middleware("/Social.asmx/PainelTrilhas", {
    params,
  });
  return res[0].data;
};

export const useStudentTracksPanel = ({ config, studentId } = {}) => {
  return useQuery({
    ...config,
    queryFn: () => getStudentTracksPanel({ alunoid: studentId }),
    queryKey: ["socialMediaPanel", { studentId, type: "tracks" }],
  });
};
